import { render, staticRenderFns } from "./WanSettings.vue?vue&type=template&id=465d0b8f&"
import script from "./WanSettings.vue?vue&type=script&lang=js&"
export * from "./WanSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports